import { buildRouteTree } from "utils/routeUtils";

export const routes = buildRouteTree({
	profile: {
		dashboard: null,
		bonuses: null,
		loyalty: null,
		transactions: null,
		history: null,
		general: null
	}
});
